<template>
	<v-dialog v-model="digital_silver_gold_edit_form_dialog_status" persistent >
	    <v-card>
		    <v-card-title>
		      <span class="text-h5">Edit Form</span>
		    </v-card-title>
		    <v-card-text>
			    <v-container>
			      	<v-form ref="form" id="digital_gold_silver_investment_edit_form_dialog" v-model="valid" lazy-validation @submit.prevent lazy-validation>
				        <v-row> 
					        <v-col cols="12" sm="6" md="4">
					            <label>Account Owner</label>
					            <v-select
					                ref="account_owner_name"
					                name="account_owner_name"
					                v-model="selected_account_owner_name"
					                :items="account_owner_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('account_owner', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{account_owner_warning_msg}}</p>
					        </v-col>


							<v-col cols="12" sm="6" md="4">
					            <label>Company Name</label>
					            <v-select
					                ref="company_name"
					                name="company_name"
					                v-model="selected_company_name"
					                :items="company_name_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('company_name', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{company_name_warning_msg}}</p>
					        </v-col>

							<v-col cols="12" sm="6" md="4">
					            <label>Type</label>
					            <v-select
					                ref="type"
					                name="type"
					                v-model="selected_type"
					                :items="type_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('type', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{type_warning_msg}}</p>
					        </v-col>

							<v-col cols="12" sm="6" md="4" v-if="selected_type == 'Gold'">
					            <label>Carat</label>
					            <v-select
					                ref="carat"
					                name="carat"
					                v-model="selected_carat"
					                :items="carat_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('carat', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{carat_warning_msg}}</p>
					        </v-col>

							<v-col cols="12" sm="6" md="4">
					            <label>Purity (In %)</label>
					            <v-select
					                ref="purity"
					                name="purity"
					                v-model="selected_purity"
					                :items="purity_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('purity', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{purity_warning_msg}}</p>
					        </v-col>

							<v-col cols="12" sm="6" md="4">
					          	<label>Invoice No.</label>
					            <v-text-field name="invoice_no" ref="invoice_no" v-model ="invoice_no"></v-text-field>
					        </v-col>
							
					        <v-col cols="12" sm="6" md="4">
					          	<label>Quantity (In gms)</label>
					            <v-text-field name="quantity" ref="quantity" v-model ="quantity"></v-text-field>
					        </v-col>
							<v-col cols="12" sm="6" md="4">
					          	<label>Amount Invested</label>
					            <v-text-field name="amount_invested" ref="amount_invested" v-model ="amount_invested"></v-text-field>
					        </v-col>
				        </v-row>
				    </v-form>    
			    </v-container>
		    </v-card-text>
		    <v-card-actions>
		      <v-spacer></v-spacer>
		      <v-btn
		        color="blue darken-1"
		        text
		        @click="close"
		      >
		        Cancel
		      </v-btn>
		      <v-btn
		        color="blue darken-1"
		        text
		        @click="save"
		      >
		        Save
		      </v-btn>
		    </v-card-actions>
	    </v-card>
	</v-dialog>
</template>
<script>
    import axios from "axios";
    import { Auth } from "aws-amplify";
	import Datepicker from 'vuejs-datepicker';
    export default {
		components: {
		  Datepicker,
		},
	  	props: ['digital_silver_gold_edit_form_dialog_status', 'get_digital_silver_gold_edit_form_data', 'get_member_list'],
	  	data: function () {
		    return { 
				account_owner_name:'',
                selected_account_owner_name:'',
				account_owner_items:[],
				account_owner_warning_msg:'',
				account_owner_warning_status:false,

				type:'',
                selected_type:'',
				type_items:[{id:'Gold', name:'Gold'}, {id:'Silver', name:'Silver'}],
				type_warning_msg:'',
				type_warning_status:false,

				carat:'',
                selected_carat:'',
				carat_items:[{id:'24k', name:'24k'}, {id:'23k', name:'23k'}, {id:'22k', name:'22k'}, {id:'18k', name:'18k'}, {id:'14k', name:'14k'}],
				carat_warning_msg:'',
				carat_warning_status:false,

				purity:'',
                selected_purity:'',
				purity_items:[{id:'999', name:'999'}, {id:'995', name:'995'}, {id:'916', name:'916'}, {id:'750', name:'750'}, {id:'585', name:'585'}],
				purity_warning_msg:'',
				purity_warning_status:false,

				quantity:'',
				amount_invested:'',
				digital_gold_silver_edit_form_dialog:this.digital_silver_gold_edit_form_dialog_status,
				invoice_no:'',

				company_name:'',
                selected_company_name:'',
				company_name_items:[{id:'MMTC-PAMP', name:'MMTC-PAMP'}, {id:'SAFEGOLD', name:'SAFEGOLD'}],
				company_name_warning_msg:'',
				company_name_warning_status:false,

			    valid:null,
				user_name:''
		    }
		},

	    created (){
			this.$loading(true)
			setTimeout(()=>{
				
				Auth.currentAuthenticatedUser({
					bypassCache: false
				}).then(user => {	
					this.user_name = user.attributes["custom:name"];
					this.account_owner_items.push({'id':user.attributes["custom:name"], 'name':user.attributes["custom:name"]});
				})
                
                let owner_error_cnt  = 'yes';
				let type_error_cnt   = 'yes';
				let carat_error_cnt  = 'yes';
				let purity_error_cnt = 'yes';
				let company_name_error_cnt = 'yes';
				this.get_member_list.forEach(owner_detail => {
					if(owner_detail.id == 0  || owner_detail.name == null){
						this.account_owner_items.push({'id':this.user_name, 'name':this.user_name}); 
					}
					else{
						this.account_owner_items.push({'id':owner_detail.name, 'name':owner_detail.name});
					}
					if(this.get_digital_silver_gold_edit_form_data.row_item_detail.owner !=null && this.get_digital_silver_gold_edit_form_data.row_item_detail.owner == owner_detail.name){
						this.selected_account_owner_name = owner_detail.name
						owner_error_cnt = 'no';
					}
				})
				if(owner_error_cnt == 'yes'){
					this.account_owner_warning_msg  = 'Uploaded owner name ('+this.get_digital_silver_gold_edit_form_data.row_item_detail.owner+') is not found in member list. Kindly choose from dropdown';
				}


				this.company_name_items.forEach(company_name_detail => {
					if(company_name_detail['name']== this.get_digital_silver_gold_edit_form_data.row_item_detail.company_name){
						this.selected_company_name =company_name_detail['name'];
						company_name_error_cnt = 'no';
					}
				})
				if(company_name_error_cnt == 'yes'){
					this.company_name_warning_msg  = 'Uploaded data ('+this.get_digital_silver_gold_edit_form_data.row_item_detail.company_name+') is not found in member list. Kindly choose from dropdown';
				}


				this.type_items.forEach(type_detail => {
					if(type_detail['name']== this.get_digital_silver_gold_edit_form_data.row_item_detail.type){
						this.selected_type =type_detail['name'];
						type_error_cnt = 'no';
					}
				})
				if(type_error_cnt == 'yes'){
					this.type_warning_msg  = 'Uploaded data ('+this.get_digital_silver_gold_edit_form_data.row_item_detail.type+') is not found in member list. Kindly choose from dropdown';
				}


				this.carat_items.forEach(carat_detail => {
					if(carat_detail['name']== this.get_digital_silver_gold_edit_form_data.row_item_detail.carat){
						this.selected_carat =carat_detail['name'];
						carat_error_cnt = 'no';
					}
				})
				if(carat_error_cnt == 'yes'){
					this.carat_warning_msg  = 'Uploaded data ('+this.get_digital_silver_gold_edit_form_data.row_item_detail.carat+') is not found in member list. Kindly choose from dropdown';
				}

				this.purity_items.forEach(purity_detail => {
					if(purity_detail['name']== this.get_digital_silver_gold_edit_form_data.row_item_detail.purity_in){
						this.selected_purity =purity_detail['name'];
						purity_error_cnt = 'no';
					}
				})
				if(purity_error_cnt == 'yes'){
					this.purity_warning_msg  = 'Uploaded data ('+this.get_digital_silver_gold_edit_form_data.row_item_detail.purity_in+') is not found in member list. Kindly choose from dropdown';
				}
				
				this.amount_invested  = this.get_digital_silver_gold_edit_form_data.row_item_detail.amount_invested;
				this.quantity         = this.get_digital_silver_gold_edit_form_data.row_item_detail.quantity_in_gms;
				this.selected_type    = this.get_digital_silver_gold_edit_form_data.row_item_detail.type;
				this.selected_carat   = this.get_digital_silver_gold_edit_form_data.row_item_detail.carat_in;
				this.selected_purity  = this.get_digital_silver_gold_edit_form_data.row_item_detail.purity;
				this.invoice_no       = this.get_digital_silver_gold_edit_form_data.row_item_detail.invoice_no;
				this.$loading(false)
			}, 3000);
			
	    },

	    methods: {
	    	removeError(type, type_val){
		        if(type == 'carat'){
		            this.carat_warning_msg = this.purity_warning_msg = '';
		            let index = this.carat_items.findIndex(x => x.name === this.selected_carat);
		            let name = this.purity_items[index].name;
		            this.selected_purity = {id:name, name:name};
		        }
		        else if(type == 'account_owner'){
		            this.account_owner_warning_msg = ''
		        }
				else if(type == 'type'){
                    this.type_warning_msg = ''	
				}
				else if(type == 'company_name'){
                    this.company_name_warning_msg = ''	
				}
				else if(type == 'purity'){
                    this.purity_warning_msg = ''
                    let index = this.purity_items.findIndex(x => x.name === this.selected_purity);
		            this.selected_carat = this.carat_items[index].name;
				}
		    },

		    close(){
                this.$emit('getDigitalSilverGoldUpdatedFormData', false)
		    },

		    save(e){
				let is_form_valid  = true;
                this.getFormData = document.querySelector("#digital_gold_silver_investment_edit_form_dialog");
				if(this.getFormData.purity.value ==''){
                   this.purity_warning_msg = "Choose Purity From List";
				   is_form_valid = false;
				}
				if(this.selected_type == 'Gold' && this.getFormData.carat.value == ''){
                    this.carat_warning_msg = "Choose Valid Carat From List";
					is_form_valid = false;
				}
				if(this.getFormData.type.value ==''){
                   this.type_warning_msg = "Choose valid type from list";
				   is_form_valid  = false;
				}
				if(this.getFormData.account_owner_name.value ==''){
                   this.account_owner_name_warning_msg = "Choose Valid Account Owner Name from list";
				   is_form_valid  = false;
				}
				if(is_form_valid  == true){
					let form_array_object = {'amount_invested' :this.getFormData.amount_invested.value,
											'invoice_no':this.getFormData.invoice_no.value,
											'is_account_owner_valid':true, 
											'is_type_valid':true, 
											'owner':this.getFormData.account_owner_name.value, 
											'purity_in':this.getFormData.purity.value,
											'is_purity_valid':true,
											'quantity_in_gms':this.getFormData.quantity.value,
											'type':this.getFormData.type.value,
											'company_name':this.getFormData.company_name.value,
											'is_company_name_valid':true
			                        	};
			        if (this.selected_type == 'Gold') {
			        	form_array_object.carat = this.getFormData.carat.value;
			        }
                    this.$emit('getDigitalSilverGoldUpdatedFormData', form_array_object);
				}
		    },

	    }
    }
</script>